/* eslint-disable indent */

const EnsuranceList = () => import('@/views/insurance/list/list.vue')
const EnsuranceDetail = () => import('@/views/insurance/detail/detail.vue')
export default [
    {
        path: '/EnsuranceList',
        name: 'EnsuranceList',
        component: EnsuranceList,
        meta: {
            keepAlive: true
        }
    }, {
        path: '/EnsuranceDetail',
        name: 'EnsuranceDetail',
        component: EnsuranceDetail,
        meta: {
            keepAlive: true
        }
    }]



// WEBPACK FOOTER //
// ./src/router/modules/ensurance.js